export const RADIOBUTTON = 5;
export const CHECKBOX = 1;
export const DROPDOWN = 2;
export const DROPDOWNALT = 3;
export const BUTTON = 10;
export const TEXTAREA = 7;
export const BUTTONEMOJI = 11;
export const SEARCHBAR = 12;
